import { EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import { DynamicPhone } from '@cian/frontend-newbuilding-call-component';
import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { BuilderCallReasonsContactButton } from 'shared/components/BuilderCallReasonsContactButton';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { getPhones } from 'shared/selectors';
import { getDynamicCalltrackingSiteBlockId } from 'shared/selectors/getDynamicCalltrackingSiteBlockId';
import { getOffer, getOfferId } from 'shared/selectors/newObject';
import { getAgent } from 'shared/selectors/newObject/getAgent';
import { formatNumber, getPhoneLink } from 'shared/utils/phone';
import { getCustomUrl } from 'shared/utils/tracking/getCustomUrl';

import { trackBuilderCallReasonsContactButtonClick } from './tracking';

export const BuilderCallReasonsContactButtonContainer: React.VFC = () => {
  const { httpApi, logger } = useApplicationContext();
  const phones = useSelector(getPhones);
  const siteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);
  const offerId = useSelector(getOfferId);

  const agent = useSelector(getAgent);
  const offer = useSelector(getOffer);
  const gaLabel = getCustomUrl(offer, agent);

  const formattedPhones = React.useMemo(
    () =>
      phones.map(phone => ({
        number: formatNumber(phone),
        link: getPhoneLink(phone),
      })),
    [phones],
  );

  const [isPhoneVisible, setPhoneVisible] = React.useState(false);

  const handlePhoneButtonClick = React.useCallback(() => {
    setPhoneVisible(true);
    trackBuilderCallReasonsContactButtonClick(gaLabel);
  }, [gaLabel]);

  if (!isPhoneVisible) {
    return <BuilderCallReasonsContactButton onClick={handlePhoneButtonClick} />;
  }

  if (!siteBlockId) {
    return <UIHeading4>{formattedPhones[0].number}</UIHeading4>;
  }

  return (
    <UIHeading4>
      <DynamicPhone
        loader={<BuilderCallReasonsContactButton loading />}
        formattedPhone={formattedPhones[0].number}
        siteBlockId={siteBlockId}
        httpApi={httpApi}
        logger={logger}
        placeType="blockBuilderCallReasons"
        pageType={EPageTypes.OfferCard}
        platformType={EPlatformTypes.WebDesktop}
        announcementId={offerId}
      />
    </UIHeading4>
  );
};
